import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { TabContent } from "@companion-core/shared/app/Interfaces/tab";

interface ConfigState {
  tabs: TabContent[];
}

interface ConfigActions {
  addTab: (tabContent: TabContent) => void;
  removeTab: (slug: string) => void;
  resetTabContainer: () => void;
}

export const initialState: ConfigState = {
  tabs: [],
};

export const useTabContainerStore = createWithEqualityFn<ConfigState & ConfigActions>()(
  (set, get) => ({
    ...initialState,
    addTab: (tabContent: TabContent) => {
      const { tabs } = get();
      const slugs = tabs.map((tab) => tab.slug);
      const newTabs = [...tabs];

      if (!slugs.includes(tabContent.slug)) {
        newTabs.push(tabContent);
      }
      set({ tabs: newTabs });
    },
    removeTab: (slug) => {
      const { tabs } = get();
      const newTabs = tabs.filter((tab) => tab.slug !== slug);
      set({ tabs: newTabs });
    },
    resetTabContainer: () => {
      set({ ...initialState });
    },
  }),
  shallow,
);
